// import { handleBeforeSend } from "./beforeSendHandlers";
import * as Sentry from "@sentry/react";
import LogRocket from "logrocket";
import { useEffect } from "react";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";
import { logRocket } from "../logrocket";
import { handleBeforeBreadcrumb } from "./beforeBreadcrumbHandlers";
import { deniedUrls, ignoredErrors } from "./constants";
import { Identify } from "./errorMonitor";
function getAccountName() {
  return window.location.hostname.split(".")[0];
}
function getCurrentPage() {
  return window.location.pathname;
}

export const SentryContainer = {
  init() {
    Sentry.init({
      dsn: import.meta.env.VITE_SENTRY_DSN,
      environment: import.meta.env.VITE_ENV,
      release: import.meta.env.VITE_APP_VERSION,
      maxBreadcrumbs: 50,
      integrations: [
        Sentry.reactRouterV6BrowserTracingIntegration({
          useEffect,
          useLocation,
          useNavigationType,
          createRoutesFromChildren,
          matchRoutes,
        }),
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(),
      ],
      denyUrls: deniedUrls(),
      ignoreErrors: ignoredErrors(),
      beforeBreadcrumb: handleBeforeBreadcrumb,
      tracesSampleRate: 0.2,
      debug: true,
      initialScope: (scope) => {
        scope.setTag("account", getAccountName());
        return scope;
      },
      beforeSend(event) {
        const logRocketSession = LogRocket.sessionURL;
        if (logRocketSession !== null && event.extra) {
          event.extra.LogRocket = logRocketSession;
        }
        return event;
      },

      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
    });
  },

  identify(value: Identify) {
    Sentry.setUser(value);
  },

  logError(error: Error, errorInfo: any = null) {
    Sentry.withScope((scope) => {
      errorInfo && scope.setExtras(errorInfo);
      scope.setTag("page", getCurrentPage());
      Sentry.captureException(error, errorInfo);
    });
  },

  extra() {
    logRocket.getSessionURL().then((value) => {
      Sentry.withScope((scope) => {
        scope.setExtra("sessionURL", value);
      });
    });
  },
};
